import React, { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';

import { AppRouts } from './routes';
import { SideMenu } from './components/custom';
import { AuthProvider, AppThemeProvider, DrawerProvider, DamProvider } from './context';
import { Auth } from './pages';
import { PluginListenerHandle } from '@capacitor/core';



const DeepLinkHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    
    let listener: PluginListenerHandle;

    const setupListener = async () => {
      listener = await CapacitorApp.addListener('appUrlOpen', (event) => {
        const url = new URL(event.url);
        const path = url.pathname;

        if (path) {
          
          navigate(path);
        }
      });
    };

    setupListener();

    
    
    return () => {
      
      if (listener) {
        listener.remove();
      }
    };
  }, [navigate]); 

  return null; 
};


export const App = () => {
  return (
    <AuthProvider>
      <AppThemeProvider>
        <Auth>
          <DrawerProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <DamProvider>
                <DeepLinkHandler />

                <SideMenu>
                  <AppRouts />
                </SideMenu>
              </DamProvider>
            </BrowserRouter>
          </DrawerProvider>
        </Auth>
      </AppThemeProvider>
    </AuthProvider>
  );
};